import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useEffect, useState } from "react";
import { text } from "stream/consumers";
import { v4 as uuidv4 } from "uuid";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Button,
} from "reactstrap";
import ApiService from "../../services/apiService";
import { toast } from "react-toastify";
import CancelIcon from "../svg/Cancel";

type calendarProps = {
  ChakId: string;
};

const Calendar = ({ ChakId }: calendarProps) => {
  const [events, setEvents] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [id, setId] = useState("");

  function bitmaskToFullCalendarDays(maskStr: string): number[] {
    const mask = Number(maskStr);

    if (Number.isNaN(mask)) return [];

    const map = [
      { bit: 1, day: 1 }, // MON
      { bit: 2, day: 2 }, // TUE
      { bit: 4, day: 3 }, // WED
      { bit: 8, day: 4 }, // THU
      { bit: 16, day: 5 }, // FRI
      { bit: 32, day: 6 }, // SAT
      { bit: 64, day: 0 }, // SUN
    ];

    return map.filter((d) => (mask & d.bit) !== 0).map((d) => d.day);
  }

  const handleDateClick = (info: any) => {
    setIsModalOpen(true);
    setSelectedDate(info.dateStr);
  };

  const handleEventClick = (clickInfo: any) => {
    setId(clickInfo.event.id);
    setInputValue(clickInfo.event.title);
    setIsModalOpen(true);
  };

  const scheduleColors = [
    "#9ad2c7",
    "#f8bebe", 
    "#b8c6f2", 
    "#fbe89b", 
    "#c7e4c7", 
    "#e4b5e4", 
    "#b3e0f7", 
    "#f7cdbd", 
    "#c7b8e0", 
    "#e0f3b8",
  ];
  
  useEffect(() => {
    const getSchedule = async () => {
      try {
        const response = await ApiService.axiosApi(
          `/schedulecalendar/${ChakId}`,
          {
            method: "GET",
          }
        );
        console.log(response);
        if (response.success) {
          const apiEvents = response.data.data.map((event: any) => {
            const color = scheduleColors[event.scheduleNo % scheduleColors.length];
            return {
              id: event.scheduleId,
              title: `Schedule ${event.scheduleNo}`,
              startTime: event.startTime,
              startRecur: new Date(Number(event.startDate * 1000)),
              endRecur: new Date(Number(event.endDate * 1000)),
              daysOfWeek: bitmaskToFullCalendarDays(event.weekDays),
              display: "auto", // 🔥 REQUIRED
              backgroundColor: color,
              borderColor: color,
             
            };
          });

          setEvents(apiEvents);
        } else {
          toast.error(response.message || "unab le to get events");
        }
      } catch (error) {
        toast.error("unavle to get events");
      }
    };
    if (ChakId) {
      getSchedule();
    }
  }, [ChakId]);

  return (
    <>
      <div className="mt-3 calendar-custom">
        <FullCalendar
          key={events.length}
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView={"dayGridMonth"}
          headerToolbar={{
            start: "today,prev,next",
            center: "title",
            end: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          events={events}
          selectable={true}
          dateClick={handleDateClick}
          eventClick={handleEventClick}
          height={400}
          eventDidMount={(info) => {
            info.el.style.backgroundColor = info.event.backgroundColor!;
            info.el.style.borderColor = info.event.borderColor!;
            info.el.style.color = info.event.textColor!;
          }}
        />
      </div>

      <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(!isModalOpen)}>
        <ModalHeader>Enter The Event You Want To Add</ModalHeader>
        <ModalBody>
          <Input
            name="text"
            type="textarea"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </ModalBody>

        <ModalFooter>
          <Button
            className="me-1"
            color="primary"
            size="sm"
            onClick={() => {
              if (inputValue && selectedDate) {
                setEvents([
                  ...events,
                  {
                    id: uuidv4(),
                    title: inputValue,
                    start: selectedDate,
                  },
                ]);
              }

              setSelectedDate(null);
              setInputValue("");
              setIsModalOpen(false);
            }}
          >
            Confirm
          </Button>

          <Button
            color="danger"
            size="sm"
            onClick={() => {
              if (id && inputValue) {
                setEvents(
                  events.filter(
                    (event: any) => event.id.toString() !== id.toString()
                  )
                );
                setIsModalOpen(false);
                setInputValue("");
              }
            }}
          >
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Calendar;
